const propertiesToSearchText = ['username', 'name', 'site_name', 'did', 'device', 'ip', 'description']

export function subscriberFilter(filter, user) {
    return subscriber => {
        if (filter) {
            // filter by unit
            if (filter.units && !filter.units.find(unit => unit == subscriber.unit_id)) return false
            // filter by search text
            if (filter.searchText) {
                let searchTerms = filter.searchText.toLowerCase().split(' ')
                for (let i = 0; i < searchTerms.length; i++) {
                    if (!propertiesToSearchText.reduce((found, key) => found || subscriber[key] && subscriber[key].toLowerCase().indexOf(searchTerms[i]) >= 0, false)) return false
                }
            }
            // filter others
            const properties = Object.keys(filter).filter(key => filter[key] && ['units', 'searchText'].indexOf(key) < 0)
            for (let i = 0; i < properties.length; i++) {
                const property = properties[i]
                let filterValue = filter[property], propertyValue = subscriber[property]
                if (typeof filterValue === 'function') {
                    if (!filterValue(propertyValue)) return false
                } else if (typeof filterValue === 'object') {
                    if (filterValue.indexOf && filterValue.indexOf(propertyValue) < 0) return false
                } else {
                    if (filterValue && filterValue.toLowerCase) filterValue = filterValue.toLowerCase()
                    if (propertyValue && propertyValue.toLowerCase) propertyValue = propertyValue.toLowerCase()
                    if (propertyValue != filterValue) return false
                }
            }
        }
        return true
    }
}

export function subscriberSort({ orderBy, reverseOrder } = { orderBy: 'status' }) {
    return (a, b) => {
        if (orderBy && a[orderBy] && b[orderBy]) {
            const orderFactor = reverseOrder ? -1 : 1
            if (!a[orderBy]) return orderFactor * -1
            if (!b[orderBy]) return orderFactor
            return (a[orderBy].localeCompare(b[orderBy]) || a.username.localeCompare(b.username)) * orderFactor
        }
        return 0
    }
}



// WEBPACK FOOTER //
// ./helper/subscriber.js